<template>
  <div class="l_coupon">
    <!-- 期限間近メッセージ -->
    <div v-if="this.showItem === 'クーポン'">
      <div class="expireMsg" v-if="this.expire_coupon === 1">
        <div class="expire_coupon">
          <img src="@/assets/img/coupon/expire_coupon.png" />
        </div>
      </div>
    </div>
    <div v-if="this.showItem === 'フリーパス'">
      <div class="expireMsg" v-if="this.expire_freepass === 1">
        <div class="expire_coupon">
          <img src="@/assets/img/coupon/expire_freepass.png" />
        </div>
      </div>
    </div>
    <!-- 絞り込みメニュー -->
    <TopMenu
      v-if="
        (isExistCoupon() && isExistFreePass()) ||
          (isExistCoupon() && isExistPremium())
      "
      :select="this.showItem"
      :freepass="isExistFreePass()"
      :premium="isExistPremium()"
      @click="tapCondition"
    />
    <div class="container" v-bind:class="{ margintop: !isExistFreePass() }">
      <!-- クーポンリスト -->
      <div
        class="list-coupon"
        v-for="(coupon, index) in currentCoupons"
        v-bind:key="`coupon_${index}`"
      >
        <FreepassCard
          v-if="isFreePass(coupon)"
          :couponId="
            coupon.data.coupon_id ? coupon.data.coupon_id : coupon.data.prize_id
          "
          :expireAt="coupon.data.expire_at"
          :category="coupon.data.coupon_category"
          :image="coupon.data.thumb_url"
          :title="coupon.data.caption"
          :headingSmall="coupon.data.heading_small"
          :headingLarge="coupon.data.heading_large"
          :type="coupon.data.type"
          :isHtml="coupon.data.is_html_display === '1'"
          :giftExpire="coupon.data.gift_expire"
          :isOff="coupon.data.is_off"
          :prize_type="coupon.data.prize_type"
          @click="() => tapFreepass(coupon)"
        />
        <CouponCard
          v-if="isCoupon(coupon)"
          :couponId="
            coupon.data.coupon_id ? coupon.data.coupon_id : coupon.data.prize_id
          "
          :expireAt="coupon.data.expire_at"
          :category="coupon.data.coupon_category"
          :image="coupon.data.thumb_url"
          :title="coupon.data.caption"
          :headingSmall="coupon.data.heading_small"
          :headingLarge="coupon.data.heading_large"
          :type="coupon.data.type"
          :isHtml="coupon.data.is_html_display === '1'"
          :giftExpire="coupon.data.gift_expire"
          :isOff="coupon.data.is_off"
          :imageSize="coupon.data.image_size"
          :target_user_type="coupon.data.target_user_type"
          @click="
            () =>
              tapCoupon(
                coupon.data.coupon_id
                  ? coupon.data.coupon_id
                  : coupon.data.prize_id,
                coupon.data.caption
              )
          "
        />
      </div>
      <!-- 表示データが0件の場合 -->
      <div class="empty-coupon" v-if="this.currentCoupons.length < 1">
        <img src="../assets/img/nocoupon.svg" alt="img_empty_coupon" />
        <p>現在、このカテゴリの<br />クーポンはありません</p>
      </div>
    </div>

    <template v-if="this.isUseAlert">
      <alert-coupon
        :image="this.currentCoupon.thumb_url"
        :type="this.currentCoupon.type"
        :isFreepass="true"
        @useCoupon="tapAcceptUseCoupon"
        @cancelCoupon="tapCancelUseCoupon"
      />
    </template>

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
  </div>
</template>

<script>
import TopMenu from '@/components/TopMenu.vue'
import CouponCard from '@/components/CouponCard.vue'
import FreepassCard from '@/components/FreepassCard.vue'
import DateFormatter from '../utils/DateFormatter.js'

import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import AlertCoupon from '@/components/Modal/AlertCoupon'

import { mapActions, mapGetters } from 'vuex'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import { FactoryTrack } from '../constant/firebase'
import '@/styles/color.css'

export default {
  name: 'Coupon',
  components: {
    TopMenu,
    CouponCard,
    FreepassCard,
    ErrorPopup,
    AlertCoupon
  },
  data: function() {
    return {
      showItem: 'クーポン',
      title: 'クーポン',
      apiType: '3',
      apiTypeFreepass: '7',
      conditionQueryString: 'condition',
      condition: '2',
      currentCoupons: [],
      currentCoupon: null,
      isError: false,
      errorMessage: '',
      errorTitle: '',
      isUseAlert: false,
      userType: '0'
    }
  },
  async created() {
    document.title = this.title // タイトル設定
    this.__checkQuertyCondition() // 条件取得
    const accTime = new DateFormatter().format(
      require('moment-timezone').tz('Asia/Tokyo')._d
    )
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.userType = json.user_type
        this.fetchCouponList(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: this.apiType,
        acc_time: accTime
      })
    } catch (e) {
      this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
      this.errorMessage = ErrorMessage.MSG_ERROR_TOKEN
      this.isError = true
      console.log(e)
    }
  },
  watch: {
    $route(to, from) {
      location.reload()
    },
    async conditionProp(val) {
      // update condition
      this.condition = this.conditionProp
    }
  },
  computed: {
    ...mapGetters({
      coupons: 'Coupon/coupons',
      expire_coupon: 'Coupon/expire_coupon',
      expire_freepass: 'Coupon/expire_freepass'
    })
  },
  methods: {
    isFreePass(coupon) {
      return this.showItem === 'フリーパス' && coupon.data.prize_type !== '0'
    },
    isCoupon(coupon) {
      return this.showItem === 'クーポン' && coupon.data.prize_type === '0'
    },
    isExistFreePass: function() {
      return this.currentCoupons.some(item => item.data.prize_type !== '0')
    },
    isExistCoupon: function() {
      return this.currentCoupons.some(item => item.data.prize_type === '0')
    },
    isExistPremium: function() {
      return this.userType === '1' || this.userType === '2'
    },
    ...mapActions('Coupon', [
      'actionFetchCoupon',
      'actionRequestExchangePrize'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', [
      'actionCallCupon',
      'actionCallFreepass',
      'actionRequestToken',
      'actionNavigateTo',
      'isTarepanda'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Modal', ['action_ToggleModal']),
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.action_ToggleModal(false)
      this.$router.go()
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.action_ToggleModal(false)
      this.isError = false
    },
    /**
     * プレミアムボタンタップ
     */
    tapPremium() {
      this.actionNavigateTo('5') // 5:プレミアム画面
    },
    /**
     * クーポンリストデータを取得
     * @param {String} token
     * @param {String} accTime
     * @param {String} userId
     */
    async fetchCouponList(token, accTime, userId) {
      this.actionToggleLoading(true)
      try {
        await this.actionFetchCoupon({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.currentCoupons = this.coupons
        // filter couponlist with target_user_type to get normal couponlist
        this.currentCoupons = this.coupons.filter(
          data => this.userType === '0' || data.data.target_user_type === '0'
          // data => data.data.target_user_type === '0'
        )
        if (this.$route.query.show !== '1') {
          this.showItem = this.isExistFreePass() ? 'フリーパス' : 'クーポン'
        }
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }

      // fixed follow issue #111
      if (this.condition && this.condition === '2') {
        this.currentCoupons = this.coupons.filter(
          data => this.condition === data.data.coupon_category
        )
      }
      this.actionToggleLoading(false)
    },
    /**
     * クーポンのボタンタップ
     *
     * @param {string} id
     * @param {string} caption
     */
    tapCoupon(id, caption) {
      try {
        this.trackEvent(FactoryTrack.createCoupon(id, caption))
      } catch (e) {
        console.log(e)
      }
      if (window.navigator.onLine) {
        this.actionCallCupon(`${id}:confirm`)
      } else {
        console.log('off line')
        this.action_ToggleModal(true)
        this.errorMessage = '通信環境の良いところで、再度お試しください。'
        this.errorTitle = 'ネットワーククエラー'
        this.errorCode = '0000000'
        this.isError = true
      }
    },
    /**
     * クーポンのボタンタップ
     *
     * @param {string} id
     * @param {string} caption
     */
    openFreepass(id, caption, imageUrl, type, coupon) {
      this.currentCoupon = coupon
      try {
        this.trackEvent(FactoryTrack.createFreepass(id, caption))
      } catch (e) {
        console.log(e)
      }
      this.isUseAlert = true
    },
    async tapFreepass(coupon) {
      if (await this.isTarepanda()) {
        this.tapCoupon(
          coupon.data.coupon_id ? coupon.data.coupon_id : coupon.data.prize_id,
          coupon.data.caption
        )
      } else {
        this.openFreepass(
          coupon.data.coupon_id ? coupon.data.coupon_id : coupon.data.prize_id,
          coupon.data.caption,
          coupon.data.thumb_url,
          coupon.data.type,
          coupon.data
        )
      }
    },
    /**
     * ExchangePrizeをコール
     */
    async fetchExchangePrize(token, accTime, userId, prizeId) {
      this.actionToggleLoading(true)
      try {
        if (this.currentCoupon.used_count === 0) {
          await this.actionRequestExchangePrize({
            token: token,
            accTime: accTime,
            userId: userId,
            prizeId: prizeId
          })
        }
        if (window.navigator.onLine) {
          this.actionCallFreepass(`1-${prizeId}`)
        } else {
          console.log('off line')
          this.action_ToggleModal(true)
          this.errorMessage = '通信環境の良いところで、再度お試しください。'
          this.errorTitle = 'ネットワーククエラー'
          this.errorCode = '0000000'
          this.isError = true
        }
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.log(e)
      }
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 300)
    },

    /**
     * クーポン利用する承諾
     */
    tapAcceptUseCoupon() {
      try {
        this.trackEvent(
          FactoryTrack.createUseCoupon(
            this.currentCoupon.prize_id,
            this.currentCoupon.caption
          )
        )
      } catch (e) {
        console.log(this.currentCoupon)
      }
      this.isUseAlert = false
      const accTime = new DateFormatter().format(new Date())
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.fetchExchangePrize(
            json.app_token,
            accTime,
            json.user_id,
            json.prize_id
          )
          window.receivedToken = null
        }
        this.actionRequestToken({
          apiType: this.apiTypeFreepass,
          acc_time: accTime,
          prize_id: this.currentCoupon.prize_id.split('-')[1]
        }) // 特典
      } catch (e) {
        console.log(e)
        this.fetchUseCoupon('', '', '', '')
      }
    },
    /**
     * クーポン利用する拒否
     */
    tapCancelUseCoupon() {
      try {
        this.trackEvent(
          FactoryTrack.createCancelCoupon(
            this.currentCoupon.prize_id,
            this.currentCoupon.caption
          )
        )
      } catch (e) {
        console.log(this.coupon)
      }
      this.isUseAlert = false
    },

    tapCondition(isSelect) {
      this.trackEvent(FactoryTrack.createCouponCondition(isSelect))
      if (isSelect === 'プレミアム') {
        this.tapPremium()
      } else {
        this.showItem = isSelect
      }
    },
    /**
     * URLクエリパラメータを取得する
     */
    __checkQuertyCondition() {
      this.condition = this.$route.query[this.conditionQueryString]
    }
  }
}
</script>

<style lang="scss" scoped>
.margintop {
  margin-top: 16px;
}

.l_coupon {
  background-color: var(--background-color);
  padding-bottom: 5px;
}

.l_coupon > .container {
  text-align: left;
  margin-left: 20px;
  margin-right: 20px;

  &.freepass {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.l_coupon > .container > .empty-coupon {
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.l_coupon > .container > .empty-coupon > p {
  font-family: HiraKakuPro-W6;
  font-size: 16px;
  line-height: 1.38;
  text-align: center;
  color: #e8c365;
}
.expireMsg {
  position: relative;
  width: 100%;
  height: 46px;
  background-color: #fde7e7;
}
.expire_coupon {
  position: relative;
  width: 65%;
  height: 40px;
  top: 0.8em;
  left: 4em;
}

.expire_coupon img {
  width: 100%;
  height: auto;
}
</style>
